import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_Student_Point } from "../../shared/data.service";
import { PointTransactionInfo, PointTransactionRequest } from "../../shared/PointTransactionRequest";

@Component({
	selector: "app-student-pbis-add",
	templateUrl: "./student-pbis-add.component.html",
	styleUrls: ["./student-pbis-add.component.css"],
})
export class StudentPBISAddComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private PBISService: DataService_Student_Point,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.user = this.dialogConfig.data.user;
		this.PersonID = this.dialogConfig.data.PersonID;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.StudentID = this.dialogConfig.data.StudentID;
		this.StudentName = this.dialogConfig.data.StudentName;
		this.CurrentBalance = this.dialogConfig.data.CurrentBalance;

		this.loadPointItem();
	}

	//////////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////////

	CurrentBalance: any = 0;

	user: any;
	StudentID: any;
	StudentName: any;

	PersonID: any;
	SchoolID: any;

	SelectedPoint: any;
	lstPoints: any = [];

	ItemLoading: any = true;
	Processing: any = false;

	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////////////
	loadPointItem() {
		this.ItemLoading = true;

		var result = this.PBISService.PBISPointItemSelectList(1, this.SchoolID); //1 for Behavior?
		result.subscribe(
			(response) => {
				this.lstPoints = response;

				this.SelectedPoint = this.lstPoints[0];

				this.ItemLoading = false;
			},
			(error) => {
				this.ItemLoading = false;
			}
		);
	}

	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////////////
	onAdd() {
		if (this.lstPoints.length == 0) {
			return;
		}

		this.Processing = true;

		//
		// Create Request
		//

		let lstTransact: PointTransactionInfo[] = [];

		let tran: PointTransactionInfo = {
			PersonID: this.PersonID,
			PointsTransactionTypeID: 1, //Earn point
			PointsItemValue: this.SelectedPoint.PointsItemValue,
			PointsItemID: this.SelectedPoint.PointsItemID,
			SchoolID: this.SchoolID,
		};

		lstTransact = [...lstTransact, tran];

		let parms: PointTransactionRequest = {
			c_PersonID: this.user.personID,
			transactionlist: lstTransact,
		};

		//
		// Call SP
		//

		var result = this.PBISService.TransactionInsert(parms);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Point was added successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the point",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.ItemLoading || this.Processing;
	}

	//////////////////////////////////////////////////////////////////
}
